import React, { useState } from "react";
import Modal from "olive-react-myoneui/lib/Modal";
import Button from "olive-react-myoneui/lib/Button";
import { downloadBaseIcon } from "../../../constants/icons";

function CertificateItem({
  className, fileType, file, title, issuedate
}) {

  const [modalShow, setModalShow] = useState(false);
  const modifiedFileURL = `${file}#toolbar=0&navpanes=0&scrollbar=0`;
  const downloadFile = () => {
    const anchor = document.createElement("a");
    anchor.href = file;
    anchor.download = title + (fileType === 'image' ? ".jpg" : ".pdf");
    anchor.click();
  };

  const renderFile = () => {
    if (fileType === 'image') {
      return <img src={file} alt="Certificate" className="img-fluid" />;
    } else if (fileType === 'pdf') {
      return <iframe src={modifiedFileURL} title={title} width="100%"></iframe>;
    } else {
      return null; 
    }
  };
  
  return (
    <>
      <div className={`${className || ""} myk__certificate-wrapper`}>
        <div className={`${fileType === 'pdf' ? 'myk__pdf-viewer' : ''} img-carousel`} onClick={() => setModalShow(true)}>
          {renderFile()}
        </div>
        <div className="mk-desc-inner-wrapper my-2">
          <a href="#" onClick={downloadFile} className="btn-certi-download text-primary d-flex align-items-center gap-1">{downloadBaseIcon} Download Certificate</a>
        </div>
      </div>
      {/* Modal */}
      <Modal
      show={modalShow}
      onHide={() => setModalShow(false)}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      contentClassName="myk__certificate-modal px-0 py-3"
      >
        <Modal.Header className="justify-content-start pb-2 px-2">
          <Modal.Title id="contained-modal-title-vcenter" className="text-start">
            <h1>{title}</h1>
            <p className="mb-0"><strong>Issue date:</strong> {issuedate}</p>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="px-2">
          {renderFile()}
        </Modal.Body>
        <Modal.Footer className="text-end pt-3">
          <Button variant="default" onClick={() => setModalShow(false)}>Close</Button>
          <Button onClick={downloadFile}>{downloadBaseIcon} &nbsp; Download</Button>
        </Modal.Footer>
      </Modal>
    </>
    )
}

export default CertificateItem;
